import React, { useEffect, useState } from "react";
import { FaRegCalendarAlt } from "react-icons/fa";

const FloatingButton = () => {

  const [showBtn, setShowBtn] = useState(false);

  useEffect(() => {

    const handleScroll = () => {

      if (window.scrollY > 200) {
        setShowBtn(true);
      } else {
        setShowBtn(false);
      }

    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);

  }, []);

  return (

    <button
      className={`floating-book-btn ${showBtn ? "show-btn" : ""}`}
      data-bs-toggle="modal"
      data-bs-target="#inspectionModal"
    >
      <FaRegCalendarAlt />
    </button>

  );

};

export default FloatingButton;